import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "alignItems", "justify", "horizontalGap", "verticalGap", "flexRef"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { useActionsCollapserContext } from '../ActionsCollapser/ActionsCollapserProvider';
import { useTabsContext } from '../TabsTransitionalOld/TabsProvider';
import { mergeOverrides } from '../../../utils/mergeOverrides';
import { deepMerge } from '../../utils/deepMerge';
import { jsx as _jsx } from "react/jsx-runtime";
const GRID_BREAKPOINT_SMALL = '544px';
const justifyContentMap = {
  around: 'space-around',
  between: 'space-between',
  center: 'center',
  end: 'end',
  start: 'start'
};
export const FlexContainer = styled.div.withConfig({
  displayName: "ButtonWrapper__FlexContainer",
  componentId: "sc-1rs325x-0"
})(({
  $alignItems,
  $justifyContent,
  $rowGap,
  $columnGap,
  $cssStyles,
  $styleOverrides
}) => {
  return deepMerge(Object.assign({
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: $alignItems,
    flexGrow: 1,
    justifyContent: justifyContentMap[$justifyContent],
    width: 'auto',
    maxWidth: 'none',
    marginLeft: `-${$columnGap}px`,
    marginTop: `-${$rowGap}px`,
    '&&& > *': {
      marginLeft: `${$columnGap}px`,
      marginTop: `${$rowGap}px`
    },
    [`@media only screen and (max-width: ${GRID_BREAKPOINT_SMALL})`]: {
      flexGrow: 1
    }
  }, $cssStyles), $styleOverrides);
});
export const ButtonWrapper = _ref => {
  var _actionsCollapserCont, _tabsContext$buttonWr;
  let {
      children,
      alignItems = 'center',
      justify = 'start',
      horizontalGap = 12,
      verticalGap = 6,
      flexRef
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  const actionsCollapserContext = useActionsCollapserContext();
  const tabsContext = useTabsContext();
  const sharedStyleOverrides = mergeOverrides((_actionsCollapserCont = actionsCollapserContext === null || actionsCollapserContext === void 0 ? void 0 : actionsCollapserContext.buttonWrapperStyleOverrides) !== null && _actionsCollapserCont !== void 0 ? _actionsCollapserCont : {}, (_tabsContext$buttonWr = tabsContext === null || tabsContext === void 0 ? void 0 : tabsContext.buttonWrapperStyleOverrides) !== null && _tabsContext$buttonWr !== void 0 ? _tabsContext$buttonWr : {});
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FlexContainer, Object.assign({
      $alignItems: alignItems,
      $justifyContent: justify,
      $rowGap: verticalGap,
      $columnGap: horizontalGap,
      $cssStyles: cssStyles,
      $styleOverrides: sharedStyleOverrides,
      ref: flexRef
    }, domProps, {
      children: children
    }))
  });
};